import { createChildListPrintContainer } from 'factories/ChildListPrint'
import actions from 'actions/rfqs/rfqItems'
import Component from 'components/Rfqs/Print/Items'

export default createChildListPrintContainer({
  actions,
  extraStateToProps: (state, props) => ({ settingsType: props.settingsType ?? 'rfq' }),
})(Component)
